/** The owner's paper build sheet, grouped so the 37 options aren't one endless list. */
export const BUILD_OPTION_GROUPS = [
  {
    title: "Suspension & stance",
    items: [
      ["Suspension upgrade", "we'll contact you for more info"],
      ["GVM increase", "we'll contact you for more info"],
      ["Big lift and big tyres", "we'll contact you for more info"],
    ],
  },
  {
    title: "Protection & recovery",
    items: [
      ["Bullbar", "hooped or hoopless - we'll send pics of the options"],
      ["Bash plates (under body protection)", ""],
      ["Side steps", "fixed or electric"],
      ["Winch", "in bar"],
      ["Rear bar / tyre carrier", "wagons only"],
      ["Snorkel", ""],
    ],
  },
  {
    title: "Lighting & comms",
    items: [
      ["Spotlights / light bar on bullbar", ""],
      ["Light bar / spotlights on roof rack", ""],
      ["Work lights / camping lights on roof rack", ""],
      ["UHF radio", ""],
      ["Switch panels for lights & accessories", "American trucks need this for lights"],
    ],
  },
  {
    title: "Touring & camping",
    items: [
      ["Drawer system", "in the tub or the back of a wagon"],
      ["Long range tank", ""],
      ["Roof rack", ""],
      ["Dual battery system", "tell us below what you'll run off it"],
      ["Solar on roof for dual battery", ""],
      ["Starlink", ""],
      ["Awning", ""],
      ["Roof top tent", ""],
      ["On board air system", "general use or airbag controls"],
    ],
  },
  {
    title: "Performance & exhaust",
    items: [
      ["Exhaust", ""],
      ["Vehicle performance tune and engine work", "some in house, some sublet"],
    ],
  },
  {
    title: "Trays, canopies & protection",
    items: [
      ["Aftermarket tray", "further consultation needed"],
      ["Aftermarket canopy for tray", "further consultation needed"],
      ["Canopy or roller shutter for tub", ""],
      ["Vehicle wraps (PPF) / paint protection / tint", "sublet"],
    ],
  },
  {
    title: "Towing",
    items: [
      ["Tow bar", ""],
      ["Towing mirrors", ""],
      ["Electrical for towing", "Anderson plugs, Tow-Pro, etc"],
      ["Airbags or Sumo springs for towing", ""],
    ],
  },
  {
    title: "Interior & sound",
    items: [
      ["Sound deadening", ""],
      ["Sound system upgrade", ""],
      ["Custom interior", ""],
    ],
  },
];

export const BUILD_NOTES = [
  "We only use the best products possible - nothing we use will be cheap.",
  "Anything we sublet is disclosed, including who it goes to and why, so only the best work goes on your vehicle.",
  "Where possible, do GVM upgrades before the vehicle is registered.",
  "Your dealer can deliver the car to us brand new for the work to be done.",
  "Once this form is in, we'll reach out to talk through all of your options.",
];
